import React from 'react';
import { Card as SCard } from 'semantic-ui-react';
import { DateRange } from '../common/DateRange'; // optional if you want birth/death info
import { useHistory } from 'react-router-dom';

export const CardTextAuthor = ({ data }) => {
  const history = useHistory();

  const handleClick = async () => {
    try {
      const profileId = data.profile.id;

      // Fetch composer matching this profile
      const res = await fetch(`http://localhost:1338/api/v1/composers/search?q=profile.id:${profileId}`);
      const json = await res.json();

      if (!json.hits?.hits?.length) return;

      const composerId = json.hits.hits[0]._source.id;
      if (composerId) history.push(`/composers/${composerId}`);
    } catch (err) {
      console.error("Error redirecting to composer:", err);
    }
  };

  return (
    <SCard
      fluid
      color="blue"
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <SCard.Content>
        <SCard.Header>{data.profile.first_name} {data.profile.last_name}</SCard.Header>
        {data.profile.birth_date && data.profile.death_date && (
          <SCard.Meta>
            <DateRange start={data.profile.birth_date} end={data.profile.death_date} />
          </SCard.Meta>
        )}
      </SCard.Content>
    </SCard>
  );
};
